import paymentsExperiments from 'bundles/epic/clients/payments';

export const generateCombineFreeTrialAndCheckoutImpression = () => {
  paymentsExperiments.get('combineFreeTrialAndCheckout');
};

export const isCombineFreeTrialAndCheckoutEnabled = () => {
  return paymentsExperiments.preview('combineFreeTrialAndCheckout') !== 'control';
};
